import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, StringField, Int32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class CaptureMidiBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new CaptureMidiBox({
            uuid,
            graph,
            name: "CaptureMidiBox",
            pointerRules: {
                accepts: [Pointers.Capture],
                mandatory: true,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "CaptureMidiBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitCaptureMidiBox, this);
    }
    get tags() {
        return CaptureMidiBox.Tags;
    }
    get deviceId() {
        return this.getField(1);
    }
    get recordMode() {
        return this.getField(2);
    }
    get channel() {
        return this.getField(10);
    }
    initializeFields() {
        return {
            1: StringField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "deviceId",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            2: StringField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "recordMode",
                deprecated: false,
                pointerRules: NoPointers,
            }, "normal"),
            10: Int32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "channel",
                deprecated: false,
                pointerRules: NoPointers,
            }, "any", "", -1),
        };
    }
}
